import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Shell } from "@/components/Shell";
import { api, apiError } from "@/lib/api";
import { CalendarDays, Save, Loader2 } from "lucide-react";

const MONTHS = ["", "janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];

function nextMonths(n = 12) {
  const out = []; const d = new Date(); let y = d.getFullYear(); let m = d.getMonth() + 1;
  for (let i = 0; i < n; i++) { out.push({ year: y, month: m, label: `${MONTHS[m]} ${y}` }); m++; if (m > 12) { m = 1; y++; } }
  return out;
}

export default function ProDisponibilites() {
  const [city, setCity] = useState("");
  const [items, setItems] = useState([]);
  const opts = nextMonths(12);
  const [pick, setPick] = useState(`${opts[0].year}-${opts[0].month}`);
  const [places, setPlaces] = useState(5);
  const [saving, setSaving] = useState(false);
  const load = useCallback(async () => {
    const r = await api.get("/school/availability");
    setCity(r.data.city || ""); setItems(r.data.items || []);
  }, []);
  useEffect(() => { load(); }, [load]);
  const save = async () => {
    const [year, month] = pick.split("-").map(Number);
    setSaving(true);
    try { await api.put("/school/availability", { year, month, places: Number(places) }); toast.success("Disponibilité enregistrée."); await load(); }
    catch (e) { toast.error(apiError(e?.response?.data?.detail)); }
    finally { setSaving(false); }
  };
  const editPlaces = async (it, val) => {
    try { await api.put("/school/availability", { year: it.year, month: it.month, places: Number(val) }); await load(); }
    catch (e) { toast.error(apiError(e?.response?.data?.detail)); }
  };
  return (
    <Shell role="school">
      <div className="p-6 lg:p-8">
        <h1 className="mb-1 flex items-center gap-2 text-2xl font-black text-neutral-900"><CalendarDays className="h-6 w-6 text-brand" /> Mes disponibilités</h1>
        <p className="mb-6 text-sm text-neutral-500">Déclare le nombre de places <strong>permis accéléré</strong> disponibles par mois pour <strong>{city || "ta ville"}</strong>. Les élèves voient uniquement le total par ville.</p>
        <div className="mb-6 flex flex-wrap items-end gap-4 rounded-2xl border border-neutral-200 bg-white p-5 shadow-sm">
          <div><label className="text-xs font-semibold text-neutral-500">Mois</label>
            <select data-testid="dispo-month" value={pick} onChange={(e) => setPick(e.target.value)} className="mt-1 rounded-xl border border-neutral-300 px-3 py-2 text-sm capitalize outline-none focus:border-brand">
              {opts.map((o) => <option key={`${o.year}-${o.month}`} value={`${o.year}-${o.month}`}>{o.label}</option>)}
            </select>
          </div>
          <div><label className="text-xs font-semibold text-neutral-500">Places</label>
            <input data-testid="dispo-places" type="number" min="0" value={places} onChange={(e) => setPlaces(e.target.value)} className="mt-1 w-24 rounded-xl border border-neutral-300 px-3 py-2 text-sm outline-none focus:border-brand" />
          </div>
          <button data-testid="dispo-save" onClick={save} disabled={saving} className="flex items-center gap-2 rounded-xl bg-brand px-4 py-2 text-sm font-bold text-white hover:bg-brand/90 disabled:opacity-60">{saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Enregistrer</button>
        </div>
        <div className="overflow-hidden rounded-2xl border border-neutral-200 bg-white shadow-sm">
          <table className="w-full text-left text-sm">
            <thead className="bg-neutral-50 text-xs uppercase tracking-wider text-neutral-400"><tr><th className="px-4 py-3">Mois</th><th className="px-4 py-3">Places déclarées</th><th className="px-4 py-3">Élèves assignés</th></tr></thead>
            <tbody className="divide-y divide-neutral-100">
              {items.length === 0 ? <tr><td colSpan={3} className="px-4 py-10 text-center text-neutral-400">Aucune disponibilité déclarée.</td></tr> : items.map((it) => (
                <tr key={it.id} className={it.past ? "opacity-50" : ""}>
                  <td className="px-4 py-3 font-semibold capitalize text-neutral-900">{it.month_label}{it.past && <span className="ml-2 text-xs text-neutral-400">(passé)</span>}</td>
                  <td className="px-4 py-3"><input type="number" min="0" defaultValue={it.places} disabled={it.past} onBlur={(e) => !it.past && Number(e.target.value) !== it.places && editPlaces(it, e.target.value)} className="w-20 rounded-lg border border-neutral-300 px-2 py-1 text-sm outline-none focus:border-brand disabled:bg-neutral-100" /></td>
                  <td className="px-4 py-3 text-neutral-500">{it.assigned_used}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Shell>
  );
}
